// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* .carousel-indicators li{\r\n    display: none;\r\n} */\r\n", "",{"version":3,"sources":["webpack://src/components/singleBanner/fixBanner.css"],"names":[],"mappings":"AAAA;;GAEG","sourcesContent":["/* .carousel-indicators li{\r\n    display: none;\r\n} */\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
